var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconFeatherEdit(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.34,
    height: 18.34,
    viewBox: "0 0 18.34 18.34",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon_feather-edit",
    "data-name": "Icon feather-edit",
    transform: "translate(-2.2 -2.018)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_86644",
    "data-name": "Path 86644",
    d: "M10.488,6H4.664A1.664,1.664,0,0,0,3,7.664V19.311a1.664,1.664,0,0,0,1.664,1.664H16.311a1.664,1.664,0,0,0,1.664-1.664V13.488",
    transform: "translate(0 -1.417)",
    fill: "none",
    stroke: "#008d9c",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_86645",
    "data-name": "Path 86645",
    d: "M20.736,3.335a1.765,1.765,0,0,1,2.5,2.5l-7.9,7.9L12,14.566l.832-3.328Z",
    transform: "translate(-4.008)",
    fill: "none",
    stroke: "#008d9c",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.6
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFeatherEdit);
export default __webpack_public_path__ + "static/media/Icon - feather-edit.fd93425ed0d8da2b30596c8cd3a328d0.svg";
export { ForwardRef as ReactComponent };